import Bugsnag from '@bugsnag/js';
import { Post } from '@interface/blog';

export default class blogService {
  /**
   * Para Server Components (páginas ISR del blog): la lista se cachea una
   * hora en el Data Cache de Next. El editor del dashboard sigue usando
   * `getBlogPosts()` sin caché.
   */
  static async getBlogPostsCached(): Promise<Post[]> {
    return blogService.getBlogPosts({ next: { revalidate: 3600 } });
  }

  static async getBlogPosts(
    init: RequestInit = { cache: 'no-store' }
  ): Promise<Post[]> {
    try {
      const url = `${process.env.NEXT_PUBLIC_BLOG_API}Blog`;

      const res = await fetch(url, init);
      if (res.ok) {
        const data = await res.json();

        if (Array.isArray(data)) {
          return data.sort(
            (a: Post, b: Post) =>
              new Date(b.creationDate).getTime() -
              new Date(a.creationDate).getTime()
          );
        }

        return data;
      } else {
        Bugsnag.notify('Error getBlogPosts' + res);
        return [];
      }
    } catch (err) {
      Bugsnag.notify('Error getBlogPosts' + err);
      return [];
    }
  }

  static async updateBlogPost(
    id: string,
    data: {
      title?: string;
      html?: string;
      metaTitle?: string;
      metaDescription?: string;
      author?: string;
      summary?: string;
    }
  ): Promise<boolean> {
    try {
      const url = `${process.env.NEXT_PUBLIC_BLOG_API}Blog/${id}`;

      const res = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        return true;
      } else {
        Bugsnag.notify('Error updateBlogPost: ' + res.status);
        return false;
      }
    } catch (err) {
      Bugsnag.notify('Error updateBlogPost: ' + err);
      return false;
    }
  }

  static async createBlogPost(data: {
    title: string;
    slug: string;
    html: string;
    author: string;
    summary?: string;
    metaTitle?: string;
    metaDescription?: string;
  }): Promise<Post | null> {
    try {
      const url = `${process.env.NEXT_PUBLIC_BLOG_API}Blog`;

      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        const created = await res.json();
        return created;
      } else {
        Bugsnag.notify('Error createBlogPost: ' + res.status);
        return null;
      }
    } catch (err) {
      Bugsnag.notify('Error createBlogPost: ' + err);
      return null;
    }
  }
}
